import { getToken, setToken, removeToken } from '@/utils/auth';
import axios from '@/utils/request';
import Route from '@/router';
const user = {
  state: {
    user: '',
    name: '',
    status: '',
    token: getToken(),
    avatar: 'static/avatar.gif',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_avatar: (state, avatar) => {
      state.avatar = avatar ? avatar : 'static/avatar.gif';
    }
  },

  actions: {
    // 登出
    LogOut({ commit, state }) {
      axios
        .get('/wyrbac/login/logout')
        .then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          removeToken();
          localStorage.removeItem('ipp_token');
          localStorage.removeItem('ipp_roles');
          localStorage.removeItem('ipp_Xcube_demo');
          Route.push('/login');
        })
        .catch(error => {
          reject(error);
        });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      commit('SET_TOKEN', '');
      removeToken();
      Route.push('/login');
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role);
        setToken(role);
        axios.get('/wyrbac/login/user-info').then(response => {
          const data = response.data;
          commit('SET_ROLES', data.roles);
          commit('SET_NAME', data.name);
          dispatch('GenerateRoutes', data); // 动态修改权限后 重绘侧边菜单
          resolve();
        });
      });
    }
  }
};

export default user;
